import { graphql, useStaticQuery } from 'gatsby';

export default (year, month, imageDirPath) => {
	const data = useStaticQuery(graphql`
		query {
			allFile(filter: { sourceInstanceName: { eq: "otamesiImage" } }, sort: { order: ASC, fields: name }) {
				nodes {
					childImageSharp {
						fluid(maxWidth: 30000) {
							...GatsbyImageSharpFluid_withWebp
							originalName
						}
					}
					relativeDirectory
					name
				}
			}
		}
	`);

	const events = [];
	data.allFile.nodes
		.filter((node) => node.relativeDirectory === imageDirPath)
		.forEach((node, index) => {
			const event = {};
			event.fluid = node.childImageSharp.fluid;
			event.imageFileName = node.childImageSharp.fluid.originalName;
			event.id = node.name;
			const result = event.imageFileName.match(/^(\d{2})_(\d{2})(\d{2})\./);
			if (result === null) {
				throw new Error(`ファイル名の形式が未知。ファイル名=${event.imageFileName}`);
			}
			const day = parseInt(result[1], 10);
			const hour = parseInt(result[2], 10);
			const minute = parseInt(result[3], 10);
			event.date = new Date(year, month - 1, day, hour, minute);
			event.strDow = ['日', '月', '火', '水', '木', '金', '土'][event.date.getDay()];

			event.strDate = `${month}/${day}(${event.strDow})${('0' + hour).slice(-2)}:${('0' + minute).slice(-2)}`;
			event.strTime = `${('0' + hour).slice(-2)}:${('0' + minute).slice(-2)}`;

			events.push(event);
		});
	return events;
};
